import * as yup from 'yup';

export const validationSchema = yup.object({
    payrollDate: yup.date().typeError("Must be a valid date").required("Required"),
    fromDate: yup.date().typeError("Must be a valid date").required("Required"),
    toDate: yup.date().typeError("Must be a valid date").required("Required"),
    salaryAmount: yup.number().typeError("Must be a valid number").required("Required"),
})